import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { apiClient } from "../api/client";

// POST /api/v1/logout clears the session cookie server-side. Clear the
// /me cache so RequireAuth bounces the user to /login on the next render.
export function useSignOut() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: async () => {
      const { error } = await apiClient.POST("/api/v1/logout", {
        params: { header: { "X-Requested-With": "xhr" } },
      });
      if (error) throw error;
    },
    onSettled: () => {
      // Whether logout succeeded or failed, drop client-side auth state and
      // bounce to /login. A failed logout (network blip) on the server side
      // leaves a still-valid cookie; the user just retries from /login.
      queryClient.setQueryData(["me"], null);
      queryClient.invalidateQueries();
      navigate("/login", { replace: true });
    },
  });
}
